const bPrintBillView = {
	props: {
		item: {
			type: Object,
			default() {
				return null;
			},
		},
	},
	data() {
		return {
			activeIndex: null,
			activeId: null,
			isMobile: false,
		}
	},
	template: `
	<div class="b-print-bill-view">

		<div class="b-print-bill-view__body">

			<div class="b-print-bill-view__col d-none d-lg-block">
				<div class="b-print-bill-view__aside">

					<!--paper bill-->
					<div class="b-paper-bill">
						<img v-bind:src="item.imageUrl" />

						<ul>
							<li v-for="(bullet, index) in item.bullets"
								v-bind:id = "bullet.id"
								v-bind:title="bullet.title"
								v-bind:style="{ top: bullet.top + '%', left: bullet.left + '%', width: bullet.width + '%', height: bullet.height + '%'  }"
								v-on:click="onClickBullet(index, bullet.id)"
								v-bind:class="[ activeIndex === index ? 'is-active' : '' ]"
								data-bs-toggle="tooltip"
								data-bs-placement="top">
								<em>{{index + 1}}</em>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="b-print-bill-view__col">
				<div class="b-print-bill-view__main">

					<ul class="b-print-bill-view__list" v-bind:id="item.id">
						<li v-for="(bullet, index) in item.bullets"
							v-bind:id="'accordion' + bullet.id">
							<h3>
								<em>{{index + 1}}</em>
								<span>{{bullet.title}}</span>
							</h3>
							<div>
								<div v-html="bullet.summary"
									class="b-article"></div>
							</div>
						</li>
					</ul>
					
				</div>
			</div>
		</div>
	</div>`,
	mounted() {

		this.$nextTick(() => {

			this.iniAccordion()
			this.iniTooltips()
		})

		this.checkMobileScreen()

		jQuery(document).on("window-resized", () => {
			this.checkMobileScreen()
		})
	},
	methods: {

		getWidth: function (left, right) {
			return right - left
		},

		iniTooltips: function () {
			jQuery('[data-bs-toggle="tooltip"]', jQuery(this.$el)).each((index, item) => {

				var tooltipEl = document.getElementById(jQuery(item).attr('id'))

				new bootstrap.Tooltip(tooltipEl, {
					container: jQuery(item).parent()
				})
			})
		},

		iniAccordion: function () {
			var self = this // do not remove

			var headerDevicesH = jQuery(".header-devices").outerHeight()

			this.accordionElem.accordion({
				//heightStyle: "panel",
				heightStyle: "content",
				collapsible: true,
				active: false,
				activate: function (event, ui) {

					self.activeIndex = self.accordionElem.accordion('option', 'active')
					self.activeId = self.accordionElem.find('li').eq(self.activeIndex).attr('id')

					if (typeof ui.newPanel[0] === 'undefined') {
						return false
					}

					if (self.isMobile) {

						if (!jQuery.isEmptyObject(ui.newHeader.offset())) {

							console.log(1, headerDevicesH)

							jQuery('html, body').animate({
								scrollTop: ui.newHeader.offset().top - headerDevicesH
							}, 'fast');
						}
					}
					else {
						self.scrollContent()
					}
				}
			})
		},

		onClickBullet: function (index, id) {
			this.activeIndex = index
			this.accordionElem.accordion("option", "active", index)
		},

		scrollContent: function () {

			var el = document.getElementById(this.activeId)
			var viewportOffset = el.getBoundingClientRect()
			// these are relative to the viewport, i.e. the window
			var top = viewportOffset.top
			var headerH = api.fn.getHeaderHeight()

			// top viewport
			if (top < 0) {
				jQuery("html, body").animate({
					scrollTop: jQuery(el).offset().top - headerH
				}, "fast")

				return false
			}

			// under viewport
			if (top - api.vars.windH > -100) {

				jQuery("html, body").animate({
					scrollTop: jQuery(el).offset().top - (api.vars.windH / 2) + (el.clientHeight / 2)
				}, "fast")

				return false
			}
		},

		checkMobileScreen() {
			this.isMobile = api.vars.windW < api.vars.scr.tablet - 1;
		},
	},

	computed: {
		accordionElem: function () {
			return jQuery(`#${this.item.id}`)
		}
	}
}